import { BigInteger } from "./bigInteger";
import { Helper } from "./helper";

// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Basic JavaScript BN library - subset useful for RSA encryption.

export class JSBN {
    private t: any;
    private s: any;

    // Bits per digit
    private dbits: number;

    // JavaScript engine analysis
    private canary = 0xdeadbeefcafe;
    private j_lm = ((this.canary & 0xffffff) == 0xefcafe);

    constructor() {
        if (this.j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
            BigInteger.prototype.am = this.am2;
            this.dbits = 30;
        }
        else if (this.j_lm && (navigator.appName != "Netscape")) {
            BigInteger.prototype.am = this.am1;
            this.dbits = 26;
        }
        else { // Mozilla/Netscape seems to prefer am3
            BigInteger.prototype.am = this.am3;
            this.dbits = 28;
        }

        BigInteger.prototype.DB = this.dbits;
        BigInteger.prototype.DM = ((1 << this.dbits) - 1);
        BigInteger.prototype.DV = (1 << this.dbits);

        Helper.BI_FP = 52;

        BigInteger.prototype.FV = Math.pow(2, Helper.BI_FP);
        BigInteger.prototype.F1 = Helper.BI_FP - this.dbits;
        BigInteger.prototype.F2 = 2 * this.dbits - Helper.BI_FP;


        // Digit conversions
        Helper.BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
        Helper.BI_RC = new Array();

        var rr, vv;
        rr = "0".charCodeAt(0);
        for (vv = 0; vv <= 9; ++vv) Helper.BI_RC[rr++] = vv;
        rr = "a".charCodeAt(0);
        for (vv = 10; vv < 36; ++vv) Helper.BI_RC[rr++] = vv;
        rr = "A".charCodeAt(0);
        for (vv = 10; vv < 36; ++vv) Helper.BI_RC[rr++] = vv;
    }

    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.

    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    private am1(i: any, x: any, w: any, j: any, c: any, n: any) {
        while (--n >= 0) {
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    private am2(i: any, x: any, w: any, j: any, c: any, n: any) {
        var xl = x & 0x7fff, xh = x >> 15;
        while (--n >= 0) {
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    private am3(i: any, x: any, w: any, j: any, c: any, n: any) {
        var xl = x & 0x3fff, xh = x >> 14;
        while (--n >= 0) {
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
}
